import { render, staticRenderFns } from "./exhibit.vue?vue&type=template&id=0c0533ac&scoped=true&"
import script from "./exhibit.vue?vue&type=script&lang=js&"
export * from "./exhibit.vue?vue&type=script&lang=js&"
import style0 from "./exhibit.vue?vue&type=style&index=0&id=0c0533ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0533ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c0533ac')) {
      api.createRecord('0c0533ac', component.options)
    } else {
      api.reload('0c0533ac', component.options)
    }
    module.hot.accept("./exhibit.vue?vue&type=template&id=0c0533ac&scoped=true&", function () {
      api.rerender('0c0533ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customChildren/exhibit.vue"
export default component.exports